import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { locationLabels } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/Locations/LocationsConfiguration/constants'

const LocationTypeSelector = ({ type, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      menuItems={Object.entries(locationLabels).map(([key, value]) => ({
        label: t(value),
        value: key,
      }))}
      value={type}
      handleChange={e => onChange(e.target.value)}
      fullWidth
      label={t('Tipo de ubicación')}
    />
  )
}

export default LocationTypeSelector
